import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import { DataGrid } from '../../components/data-grid/data-grid';
import React, { useEffect, useState } from 'react';
import { SubHeader } from '../organizations/subheader';
import { styles } from './dictionary-styles';
import { dictionaryListcolDefs, getEndpointDataByTenantId, gridOptions } from './dictionary-list-constants';
import { defaultDictionary } from '../../tests/fixtures/stubs/dictionary';
export const DictionaryList = (props)=>{
    const classes = styles();
    const { navigate, onSelection, viewOnly, sortablePageable, selectedOrg, resetStateToDefault } = props;
    const [pageSize, setPageSize] = useState(25);
    useEffect(()=>{
        const defaultData = {
            selectedDictionary: defaultDictionary,
            selectedRowIndex: -1
        };
        resetStateToDefault && resetStateToDefault(defaultData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleAddDictionary = ()=>{
        if (navigate) {
            const path = window.location.pathname;
            navigate(path + `/dictionary/upload/new`);
        }
    };
    const handleSelection = (item)=>{
        const path = window.location.pathname;
        onSelection({
            data: item,
            path: path + `/dictionary/${item.name}`
        });
    };
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(SubHeader, {
                title: 'Dictionaries',
                className: classes.text,
                actionName: viewOnly ? '' : 'Create Dictionary',
                onActionClick: handleAddDictionary,
                pageSize: pageSize,
                onPageSizeChange: onPageSizeChange
            }),
            /*#__PURE__*/ _jsx(Box, {
                paddingTop: 5,
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    columnDefs: dictionaryListcolDefs,
                    gridOptions: gridOptions,
                    endpointData: getEndpointDataByTenantId(selectedOrg.key),
                    serverSideInfiniteScroll: true,
                    filterableOptions: sortablePageable.filterableOptions,
                    onRowClicked: (item)=>{
                        handleSelection(item?.data);
                    },
                    paginationPageSize: pageSize
                })
            })
        ]
    });
};
